import type { PrimeVueLocaleOptions } from 'primevue/config'

/**
 * PrimeVue's own texts in German that the app shows: the password field's prompt (read out
 * by screen readers) and its strength words. English is PrimeVue's built-in default.
 * `App.vue` switches between the two with the app's language.
 */
export const primeVueLocaleDe: Partial<PrimeVueLocaleOptions> = {
  passwordPrompt: 'Passwort eingeben',
  weak: 'Schwach',
  medium: 'Mittel',
  strong: 'Stark',
}
